import { Suspense } from "react"
import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"
import { NotificationCenterDashboardOverview } from "@/features/notification-center"

export function NotificationCenterPage() {
  const { t } = useTranslation()

  return (
    <main className="flex w-full flex-1 flex-col">
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              label: t("sidebar.notifications"),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 p-4 @container">
        <Suspense>
          <NotificationCenterDashboardOverview />
        </Suspense>
      </section>
    </main>
  )
}
